import { action, makeObservable, observable } from "mobx";
import ProgressIndicatorModel, {
  ProgressIndicatorModel as IProgressIndicatorModel
} from "../../../../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import TrainingCoursesApi, {
  TrainingCoursesApi as ITrainingCoursesApi
} from "../../../../../../../../services/api/v2/trainingCourses/TrainingCourses.api";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";

export class ProcessLinkModalModel {
  @observable selectedProjectProcessIds: number[] = [];
  @observable isLoading: boolean = true;
  organisationId: number;
  projectId: number;
  trainingCoursesProvider: ITrainingCoursesApi;
  trainingCourse: FP.Entities.ITrainingCourse;
  httpProgress: IProgressIndicatorModel;

  /**
   *
   */
  constructor(organisationId: number, projectId: number, trainingCourse: FP.Entities.ITrainingCourse) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.trainingCoursesProvider = TrainingCoursesApi;
    this.httpProgress = ProgressIndicatorModel;
    this.trainingCourse = trainingCourse;
  }

  onMount = async () => {
    await this.getSelectedProjectProcesses();
    this.setIsLoading(false);
  };

  @action
  setSelectedProjectProcesses = (selectedProjectProcessIds: number[]) => {
    this.selectedProjectProcessIds = selectedProjectProcessIds;
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  getSelectedProjectProcesses = async () => {
    const res = await this.trainingCoursesProvider.getTrainingCourseProcessesByTrainingCourseId(
      this.organisationId,
      this.projectId,
      this.trainingCourse.id
    );

    if (!res || res.isError) return;

    this.setSelectedProjectProcesses(res.payload);
  };

  assignActionsToTrainingCourses = async (projectProcessIds, onAssignSuccess?: any) => {
    await this.trainingCoursesProvider
      .addBulkProjectProcessesToTrainingCourses(
        this.organisationId,
        this.projectId,
        [this.trainingCourse.id],
        projectProcessIds
      )
      .then(async e => await onAssignSuccess());

    ModalContext.hide();
  };
}
